import React, {useRef, useState} from "react";
import Modal from "react-responsive-modal";

const useModalComponent = ( ModalComponent ) =>
{
    const defaultState =  { openState: false, params : { mode: 'none' } } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    const resolvePromise = useRef(null);

    const onClickActivate = (params) =>
    {
        return new Promise((resolve, reject) => {
            resolvePromise.current = resolve ;

            setDialog ({ openState: true, params: { ...params }});
        })
    }

    const onCloseModal = () =>
    {
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( null ) ;
        }

        setDialog (defaultState);
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.params.mode !== 'none' && <ModalComponent onSaveCompleted={onSaveComplete} onClose={onCloseModal} {...dialog.params} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalComponent ;
